/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IDefinition } from '../../core/models/common/IDefinition';
import { Schema } from '../../core/models/common/Schema';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { IOasPropertySchema } from '../../openapi/models/IOasPropertySchema';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasSchema } from '../../openapi/models/OasSchema';

/**
 * A command used to rename a schema definition, along with all references to it.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class RenameSchemaDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameSchemaDefinitionCommand] Executing.");
        this._references = <any>([]);
        if(this._renameSchemaDefinition(<OasDocument>document, this._oldName, this._newName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            let newRef : string = this._nameToReference(this._newName);
            let schemaFinder : RenameSchemaDefinitionCommand.SchemaRefFinder = new RenameSchemaDefinitionCommand.SchemaRefFinder(oldRef);
            let schemas : Array<Schema> = schemaFinder.findIn(document);
            for(let index199=0; index199 < schemas.length; index199++) {
                let schema = schemas[index199];
                {
                    /* add */(this._references.push(Library.createNodePath(schema))>0);
                    schema.$ref = newRef;
                }
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameSchemaDefinitionCommand] Reverting.");
        if(this._renameSchemaDefinition(<OasDocument>document, this._newName, this._oldName)) {
            let oldRef : string = this._nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let schema : OasSchema = <OasSchema>ref.resolve(document);
                        schema.$ref = oldRef;
                    }
                })(oldRef));
            }
        }
    }

    /**
     * Convert a simple name to a reference.  This will be different for 2.0 vs. 3.0
     * data models.
     * @param {string} name
     * @return {string}
     */
    abstract _nameToReference(name : string) : string;

    /**
     * Called to actually change the name of the schema definition.  This impl will vary
     * depending on the OAI data model version.  Returns true if the rename actually happened.
     * @param {OasDocument} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    abstract _renameSchemaDefinition(document : OasDocument, fromName : string, toName : string) : boolean;
}
RenameSchemaDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand";
RenameSchemaDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameSchemaDefinitionCommand {

    /**
     * Constructor.
     * @param {string} reference
     * @class
     * @extends CombinedVisitorAdapter
     */
    export class SchemaRefFinder extends CombinedVisitorAdapter {
        _reference : string;

        _schemas : Array<Schema>;

        public constructor(reference : string) {
            super();
            if(this._reference===undefined) this._reference = null;
            this._schemas = <any>([]);
            this._reference = reference;
        }

        public findIn(document : Document) : Array<Schema> {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this._schemas;
        }

        _accept(schema : Schema) : boolean {
            return ModelUtils.isDefined(schema.$ref) && NodeCompat.equals(schema.$ref, this._reference);
        }

        processSchema(schema : Schema) {
            if(this._accept(schema)) {
                /* add */(this._schemas.push(schema)>0);
            }
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
         * @param {Schema} node
         */
        public visitSchema(node : Schema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
         * @param {*} node
         */
        public visitSchemaDefinition(node : IDefinition) {
            this.processSchema(<Schema><any>node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitPropertySchema(io.apicurio.datamodels.openapi.models.IOasPropertySchema)
         * @param {*} node
         */
        public visitPropertySchema(node : IOasPropertySchema) {
            this.processSchema(<Schema><any>node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAdditionalPropertiesSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitAllOfSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
         * @param {OasSchema} node
         */
        public visitItemsSchema(node : OasSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
         * @param {Oas30Schema.Oas30AnyOfSchema} node
         */
        public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
         * @param {Oas30Schema.Oas30OneOfSchema} node
         */
        public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
            this.processSchema(node);
        }

        /**
         * @see io.apicurio.datamodels.combined.visitors.CombinedVisitorAdapter#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
         * @param {Oas30Schema.Oas30NotSchema} node
         */
        public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
            this.processSchema(node);
        }
    }
    SchemaRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand.SchemaRefFinder";
    SchemaRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}




import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';

